import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { takeUntil } from "rxjs/operators";
import { Goods, GoodsUnit } from "../../models/goods.model";

@Component({
  selector: "ngx-goods-form",
  templateUrl: "./goods-form.component.html",
  styleUrls: ["./goods-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoodsFormComponent extends BaseFormComponent<Goods> {
  isloading: boolean = false;
  activeTabTitle: string = "واحد سنجش فرعی";
  @ViewChild("defaultUnit") public defaultUnit: EditableGridComponent;
  @ViewChild("goodsBarCodes") public goodsBarCodes: EditableGridComponent;
  GoodsUnits: form_control[];
  GoodsBarCodes: form_control[];
  hasCheckBoxLookUpTree: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "Goods";
    this.label = this.translate("ClientApp.BackOffice.INV.Goods.Good");
    this.selectorService.setHasDefaultValue("CostSubLedgerId", false);
    this.selectorService.setHasDefaultValue("DetailLedgerId", false);
    super.ngOnInit();
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.GoodsUnits = this.getDetailControlModels("GoodsUnits");
    this.GoodsBarCodes = this.getDetailControlModels("GoodsBarCodes");
  }
  setMaxCode() {
    if (!this.isloading) {
      this.isloading = true;
      if (!this.model.Code) this.model.Code = "";
      if (!this.model.GoodsGroupId && this.formGroup && this.formGroup.controls["GoodsGroupId"])
        this.model.GoodsGroupId = this.formGroup.controls["GoodsGroupId"].value;
      this.httpCommonService
        .get(this.apiName + "/" + this.model.GoodsGroupId + "/" + this.model.Code)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.isloading = false;
            if (!this.model) this.model = new Goods();
            if (data) {
              this.model["Code"] = data["MaxCode"] as string;
            }
            this.setdefault();
            this.setValue("Code", this.model["Code"]);
          },
          (error) => {
            this.isloading = false;
            this.getFailedHelper(error);
          }
        );
    }
  }
  onRowSelected($event) {}
  onChange($event) {
    if (this.isNewRow) {
      if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("GoodsGroup")) {
        this.formGroup.controls["Code"].setValue($event.data.TreeCode);
        this.model.Title = $event.data.TreePath;
        this.model.Code = $event.data.TreeCode;
        this.model.GoodsGroupId = $event.data.Id;
        this.setMaxCode();
      } else if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Unit")) {
        this.formGroup.controls["DefaultUnitId"].setValue($event.data.Id);
        this.model.DefaultUnitId = $event.data.Id;
        this.model.DefaultUnitCode = $event.data.Code;
        this.model.DefaultUnitTitle = $event.data.Title;
      }
    }
  }
  setdefault() {
    if (!this.model.GoodsUnits) this.model.GoodsUnits = [];
    if (!this.model.GoodsBarCodes) this.model.GoodsBarCodes = [];
    if (this.model.Active === undefined) this.model.Active = true;
    if (this.model.IsGoods === undefined) this.model.IsGoods = true;
    if (this.model.IsMarketable === undefined) this.model.IsMarketable = false;
    if (this.model.HasTracing === undefined) this.model.HasTracing = false;
    if (this.model.HasTaxDuty === undefined) this.model.HasTaxDuty = true;
    if (this.model.HasExpiryDate === undefined) this.model.HasExpiryDate = false;
  }
  addControl() {
    this.cd.markForCheck();
  }
  beforupdate() {
    if (this.goodsBarCodes) this.goodsBarCodes.saveCurrent();
    if (this.defaultUnit) this.defaultUnit.saveCurrent();
    if (this.isValid()) {
      if (
        this.model.GoodsUnits &&
        this.model.GoodsUnits.length > 0 &&
        this.model.GoodsUnits.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached && x.IsDefault)
      ) {
        let defaultunit: GoodsUnit = this.model.GoodsUnits.find((x) => x.IsDefault) as GoodsUnit;
        this.formGroup.controls["DefaultUnitId"].setValue(defaultunit.UnitId);
        this.model.DefaultUnitId = defaultunit.UnitId;
        this.model.DefaultUnitCode = defaultunit.UnitCode;
        this.model.DefaultUnitTitle = defaultunit.UnitTitle;
      } else {
        this.formGroup.controls["DefaultUnitId"].setValue(this.formGroup.controls["UnitId"].value);
        this.formGroup.controls["DefaultUnitCode"].setValue(this.formGroup.controls["UnitCode"].value);
        this.formGroup.controls["DefaultUnitTitle"].setValue(this.formGroup.controls["UnitTitle"].value);
        this.model.DefaultUnitId = this.formGroup.controls["UnitId"].value;
        this.model.DefaultUnitCode = this.formGroup.controls["UnitCode"].value;
        this.model.DefaultUnitTitle = this.formGroup.controls["UnitTitle"].value;
      }
    }
    this.model.GoodsUnits.forEach((x) => {
      if (!x.GoodsId) x.GoodsId = 0;
    });
  }
  valueChanges($event) {
    if (this.defaultUnit && this.defaultUnit.LookupData["Unit/ReadLookUp"]) {
      let UnitId = this.formGroup.controls["UnitId"].value;
      this.defaultUnit.LookupData["Unit/ReadLookUp"] = this.defaultUnit.LookupData["Unit/ReadLookUp"].filter((x) => x["Id"] !== UnitId);
    }
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  ngOnDestroy() {
    super.ngOnDestroy();
    this.selectorService.setHasDefaultValue("CostSubLedgerId", undefined);
    this.selectorService.setHasDefaultValue("DetailLedgerId", undefined);
    this.GoodsUnits = undefined;
    this.GoodsBarCodes = undefined;
  }
}
